import { ZDrofusArticleProperty } from "./project.schema";
import { DROFUS_MODELLED_MAIN_FILTER } from "./drofusOccurrenceFilter";
import { z } from "zod";
import { ZDateish, ZObjectIdString, ZProjectNo } from "./foundationSchema";
const nullableString = z.string().nullable().optional();
const nullableStringOrNumber = z.union([z.string(), z.number()]).nullable().optional();
const nullableNumber = z.number().nullable().optional();
const nullableBoolean = z.boolean().nullable().optional();
const nullableNumberArray = z.array(z.number()).nullable().optional();
const nullableStringArray = z.array(z.string()).nullable().optional();
const sourceValue = z
    .union([
    z.string(),
    z.number(),
    z.boolean(),
    z.array(z.string()),
    z.array(z.number()),
    z.null(),
])
    .optional();
export const DROFUS_INTERFACE_OCCURRENCE_SELECT_FIELDS = [
    "id",
    "quantity",
    "existing_quantity",
    "net_quantity",
    "classification_number",
    "run_no",
    "occurrence_name",
    "comment",
    "equipment_list_type_id",
    "equipment_list_type_id_name",
    "room_id",
    "room_id_room_func_no",
    "room_id_architect_no",
    "room_id_full_name",
    "room_id_room_classification_103_classification_entry_id_code",
    "room_id_room_classification_109_classification_entry_id_code",
    "article_id",
    "article_id_number",
    "article_id_name",
    "article_id_responsibility_responsibility",
    "article_id_to_be_drawn",
    "article_id_bip",
    "occurrence_responsibility",
    "responsibility",
    "priority",
    "primary_system_id",
    "is_sub_occurrence",
    "sub_occurrence_depth",
    "has_ifc_guids",
    "ifc_guids",
    "status_text",
    "name_or_item_name",
    "occurrence_classification_109_classification_entry_id_code",
    "is_system_component",
    "is_component",
    "is_base_for_systems",
    "system_membership",
    "ce4_d1_code",
    "ce4_d2_code",
    "ce4_d3_code",
    "ce109_id_or_parents",
    "ce146_id_or_parents",
    "ce149_id_or_parents",
    "ce150_id_or_parents",
    "composite_1",
    "composite_2",
    "composite_34",
    "composite_35",
    "composite_36",
    "composite_37",
    "composite_41",
    "occurrence_data_01_10_10_10",
    "occurrence_data_01_10_11_10",
    "occurrence_data_13_10_01_01",
    "occurrence_data_13_10_10_10",
    "occurrence_data_13_10_11_10",
    "occurrence_data_03_01_01_01",
    "occurrence_data_03_01_03_01",
    "occurrence_data_03_01_04_01",
    "occurrence_data_03_01_05_01",
    "occurrence_data_03_03_02_01",
    "occurrence_data_03_04_01_01",
    "occurrence_data_03_04_02_01",
    "occurrence_data_03_04_03_01",
    "article_id_dyn_article_20101010",
    "article_id_dyn_article_20101011",
    "article_id_dyn_article_20101110",
    "article_id_dyn_article_20101111",
    "article_id_dyn_article_20101210",
    "article_id_dyn_article_20101211",
    "article_id_dyn_article_20111610",
    "article_id_dyn_article_20111611",
    "article_id_dyn_article_20111010",
    "article_id_dyn_article_20111012",
    "article_id_dyn_article_20111110",
    "article_id_dyn_article_20111112",
    "article_id_dyn_article_20111410",
    "article_id_dyn_article_20111411",
    "article_id_dyn_article_20111510",
    "article_id_dyn_article_20111511",
    "article_id_dyn_article_20111810",
    "article_id_dyn_article_20111811",
    "article_id_dyn_article_20121010",
    "article_id_dyn_article_20121011",
    "article_id_dyn_article_20121810",
    "article_id_dyn_article_20121811",
    "article_id_dyn_article_20121110",
    "article_id_dyn_article_20121111",
    "article_id_dyn_article_20121910",
    "article_id_dyn_article_20121911",
    "article_id_dyn_article_20121210",
    "article_id_dyn_article_19101010",
    "article_id_dyn_article_19101011",
    "article_id_dyn_article_19101111",
    "article_id_dyn_article_19141110",
    "article_id_dyn_article_19141111",
    "article_id_dyn_article_19141210",
    "article_id_dyn_article_19141310",
    "article_id_dyn_article_19141410",
    "article_id_dyn_article_02020101",
    "article_id_dyn_article_02020201",
    "article_id_dyn_article_02020601",
    "article_id_dyn_article_02020301",
    "article_id_dyn_article_02020401",
    "article_id_dyn_article_02020501",
    "article_id_dyn_article_02010101",
    "article_id_dyn_article_02010102",
    "article_id_dyn_article_02010201",
    "article_id_dyn_article_02010202",
    "article_id_dyn_article_02010301",
    "article_id_dyn_article_02010302",
    "article_id_dyn_article_02010401",
    "article_id_dyn_article_02010402",
    "article_id_dyn_article_02030101",
    "article_id_dyn_article_02030201",
    "article_id_dyn_article_02030301",
    "article_id_dyn_article_17151011",
    "article_id_dyn_article_17151111",
    "article_id_dyn_article_17151310",
    "article_id_dyn_article_14101010",
    "article_id_dyn_article_14101110",
    "article_id_dyn_article_14101310",
    "article_id_dyn_article_14101810",
    "article_id_dyn_article_14101610",
    "article_id_dyn_article_14111010",
    "article_id_dyn_article_14111110",
    "article_id_dyn_article_14111510",
    "article_id_dyn_article_14121010",
    "article_id_dyn_article_14121110",
    "article_id_dyn_article_14121210",
    "article_id_dyn_article_14121310",
    "article_id_dyn_article_14151012",
    "article_id_dyn_article_14161010",
    "article_id_dyn_article_14161210",
    "article_id_dyn_article_15101010",
    "article_id_dyn_article_15101110",
    "article_id_dyn_article_15101210",
    "article_id_dyn_article_15101310",
    "article_id_dyn_article_15102110",
    "article_id_dyn_article_15102210",
    "article_id_dyn_article_15101610",
    "article_id_dyn_article_15102010",
    "article_id_dyn_article_15101710",
    "article_id_dyn_article_15101810",
    "article_id_dyn_article_15101410",
    "article_id_dyn_article_15101510",
    "article_id_dyn_article_15101910",
    "article_id_dyn_article_15121010",
    "article_id_dyn_article_15111010",
];
export const DROFUS_INTERFACE_OCCURRENCE_FIELD_GROUPS = [
    "occurrence",
    "room",
    "article",
    "system",
    "tfmStatus",
    "occurrenceData",
    "articleNeeds",
];
export const DROFUS_INTERFACE_OCCURRENCE_FIELD_GROUP_BY_ID = {
    id: "occurrence",
    quantity: "occurrence",
    existing_quantity: "occurrence",
    net_quantity: "occurrence",
    classification_number: "occurrence",
    run_no: "occurrence",
    occurrence_name: "occurrence",
    comment: "occurrence",
    equipment_list_type_id: "occurrence",
    equipment_list_type_id_name: "occurrence",
    room_id: "occurrence",
    room_id_room_func_no: "room",
    room_id_architect_no: "room",
    room_id_full_name: "room",
    room_id_room_classification_103_classification_entry_id_code: "room",
    room_id_room_classification_109_classification_entry_id_code: "room",
    article_id: "occurrence",
    article_id_number: "article",
    article_id_name: "article",
    article_id_responsibility_responsibility: "article",
    article_id_to_be_drawn: "article",
    article_id_bip: "article",
    occurrence_responsibility: "occurrence",
    responsibility: "occurrence",
    priority: "occurrence",
    primary_system_id: "system",
    is_sub_occurrence: "occurrence",
    sub_occurrence_depth: "occurrence",
    has_ifc_guids: "occurrence",
    ifc_guids: "occurrence",
    status_text: "occurrence",
    name_or_item_name: "occurrence",
    occurrence_classification_109_classification_entry_id_code: "occurrence",
    is_system_component: "system",
    is_component: "occurrence",
    is_base_for_systems: "system",
    system_membership: "system",
    ce4_d1_code: "tfmStatus",
    ce4_d2_code: "tfmStatus",
    ce4_d3_code: "tfmStatus",
    ce109_id_or_parents: "tfmStatus",
    ce146_id_or_parents: "tfmStatus",
    ce149_id_or_parents: "tfmStatus",
    ce150_id_or_parents: "tfmStatus",
    composite_1: "tfmStatus",
    composite_2: "tfmStatus",
    composite_34: "tfmStatus",
    composite_35: "tfmStatus",
    composite_36: "tfmStatus",
    composite_37: "tfmStatus",
    composite_41: "tfmStatus",
    occurrence_data_01_10_10_10: "occurrenceData",
    occurrence_data_01_10_11_10: "occurrenceData",
    occurrence_data_13_10_01_01: "occurrenceData",
    occurrence_data_13_10_10_10: "occurrenceData",
    occurrence_data_13_10_11_10: "occurrenceData",
    occurrence_data_03_01_01_01: "occurrenceData",
    occurrence_data_03_01_03_01: "occurrenceData",
    occurrence_data_03_01_04_01: "occurrenceData",
    occurrence_data_03_01_05_01: "occurrenceData",
    occurrence_data_03_03_02_01: "occurrenceData",
    occurrence_data_03_04_01_01: "occurrenceData",
    occurrence_data_03_04_02_01: "occurrenceData",
    occurrence_data_03_04_03_01: "occurrenceData",
    article_id_dyn_article_20101010: "articleNeeds",
    article_id_dyn_article_20101011: "articleNeeds",
    article_id_dyn_article_20101110: "articleNeeds",
    article_id_dyn_article_20101111: "articleNeeds",
    article_id_dyn_article_20101210: "articleNeeds",
    article_id_dyn_article_20101211: "articleNeeds",
    article_id_dyn_article_20111610: "articleNeeds",
    article_id_dyn_article_20111611: "articleNeeds",
    article_id_dyn_article_20111010: "articleNeeds",
    article_id_dyn_article_20111012: "articleNeeds",
    article_id_dyn_article_20111110: "articleNeeds",
    article_id_dyn_article_20111112: "articleNeeds",
    article_id_dyn_article_20111410: "articleNeeds",
    article_id_dyn_article_20111411: "articleNeeds",
    article_id_dyn_article_20111510: "articleNeeds",
    article_id_dyn_article_20111511: "articleNeeds",
    article_id_dyn_article_20111810: "articleNeeds",
    article_id_dyn_article_20111811: "articleNeeds",
    article_id_dyn_article_20121010: "articleNeeds",
    article_id_dyn_article_20121011: "articleNeeds",
    article_id_dyn_article_20121810: "articleNeeds",
    article_id_dyn_article_20121811: "articleNeeds",
    article_id_dyn_article_20121110: "articleNeeds",
    article_id_dyn_article_20121111: "articleNeeds",
    article_id_dyn_article_20121910: "articleNeeds",
    article_id_dyn_article_20121911: "articleNeeds",
    article_id_dyn_article_20121210: "articleNeeds",
    article_id_dyn_article_19101010: "articleNeeds",
    article_id_dyn_article_19101011: "articleNeeds",
    article_id_dyn_article_19101111: "articleNeeds",
    article_id_dyn_article_19141110: "articleNeeds",
    article_id_dyn_article_19141111: "articleNeeds",
    article_id_dyn_article_19141210: "articleNeeds",
    article_id_dyn_article_19141310: "articleNeeds",
    article_id_dyn_article_19141410: "articleNeeds",
    article_id_dyn_article_02020101: "articleNeeds",
    article_id_dyn_article_02020201: "articleNeeds",
    article_id_dyn_article_02020601: "articleNeeds",
    article_id_dyn_article_02020301: "articleNeeds",
    article_id_dyn_article_02020401: "articleNeeds",
    article_id_dyn_article_02020501: "articleNeeds",
    article_id_dyn_article_02010101: "articleNeeds",
    article_id_dyn_article_02010102: "articleNeeds",
    article_id_dyn_article_02010201: "articleNeeds",
    article_id_dyn_article_02010202: "articleNeeds",
    article_id_dyn_article_02010301: "articleNeeds",
    article_id_dyn_article_02010302: "articleNeeds",
    article_id_dyn_article_02010401: "articleNeeds",
    article_id_dyn_article_02010402: "articleNeeds",
    article_id_dyn_article_02030101: "articleNeeds",
    article_id_dyn_article_02030201: "articleNeeds",
    article_id_dyn_article_02030301: "articleNeeds",
    article_id_dyn_article_17151011: "articleNeeds",
    article_id_dyn_article_17151111: "articleNeeds",
    article_id_dyn_article_17151310: "articleNeeds",
    article_id_dyn_article_14101010: "articleNeeds",
    article_id_dyn_article_14101110: "articleNeeds",
    article_id_dyn_article_14101310: "articleNeeds",
    article_id_dyn_article_14101810: "articleNeeds",
    article_id_dyn_article_14101610: "articleNeeds",
    article_id_dyn_article_14111010: "articleNeeds",
    article_id_dyn_article_14111110: "articleNeeds",
    article_id_dyn_article_14111510: "articleNeeds",
    article_id_dyn_article_14121010: "articleNeeds",
    article_id_dyn_article_14121110: "articleNeeds",
    article_id_dyn_article_14121210: "articleNeeds",
    article_id_dyn_article_14121310: "articleNeeds",
    article_id_dyn_article_14151012: "articleNeeds",
    article_id_dyn_article_14161010: "articleNeeds",
    article_id_dyn_article_14161210: "articleNeeds",
    article_id_dyn_article_15101010: "articleNeeds",
    article_id_dyn_article_15101110: "articleNeeds",
    article_id_dyn_article_15101210: "articleNeeds",
    article_id_dyn_article_15101310: "articleNeeds",
    article_id_dyn_article_15102110: "articleNeeds",
    article_id_dyn_article_15102210: "articleNeeds",
    article_id_dyn_article_15101610: "articleNeeds",
    article_id_dyn_article_15102010: "articleNeeds",
    article_id_dyn_article_15101710: "articleNeeds",
    article_id_dyn_article_15101810: "articleNeeds",
    article_id_dyn_article_15101410: "articleNeeds",
    article_id_dyn_article_15101510: "articleNeeds",
    article_id_dyn_article_15101910: "articleNeeds",
    article_id_dyn_article_15121010: "articleNeeds",
    article_id_dyn_article_15111010: "articleNeeds",
};
export const DROFUS_INTERFACE_OCCURRENCE_FIELD_LABELS = {
    id: "ID",
    quantity: "Antall",
    existing_quantity: "Eksisterende antall",
    net_quantity: "Netto antall",
    classification_number: "Nummer",
    run_no: "Løpenummer",
    occurrence_name: "Navn",
    comment: "Kommentar",
    equipment_list_type_id: "Utstyrsliste ID",
    equipment_list_type_id_name: "Utstyrsliste: Navn",
    room_id: "Rom ID",
    room_id_room_func_no: "Rom: Funksjonsnummer",
    room_id_architect_no: "Rom: Arkitektnummer",
    room_id_full_name: "Rom: Fullt navn",
    room_id_room_classification_103_classification_entry_id_code: "Rom: Klassifisering 103 kode",
    room_id_room_classification_109_classification_entry_id_code: "Rom: Klassifisering 109 kode",
    article_id: "Artikkel ID",
    article_id_number: "Artikkel: Artikkelnr",
    article_id_name: "Artikkel: Navn",
    article_id_responsibility_responsibility: "Artikkel: Ansvar",
    article_id_to_be_drawn: "Artikkel: Skal modelleres",
    article_id_bip: "Artikkel: BIP",
    occurrence_responsibility: "Ansvar",
    responsibility: "Overstyrt ansvar: Ansvar",
    priority: "Prioritet",
    primary_system_id: "Primærsystem ID",
    is_sub_occurrence: "Er tilleggsartikkel",
    sub_occurrence_depth: "Tilleggsforekomst dybde",
    has_ifc_guids: "Har IFC GUID",
    ifc_guids: "IFC GUID",
    status_text: "Status",
    name_or_item_name: "Komponentnavn",
    occurrence_classification_109_classification_entry_id_code: "MMI (Prosjektert): Kode",
    is_system_component: "System",
    is_component: "Komponent",
    is_base_for_systems: "Har systemer",
    system_membership: "Er medlem av systemene",
    ce4_d1_code: "TFM Lokasjonskode: Kode [1]",
    ce4_d2_code: "TFM Lokasjonskode: Kode [2]",
    ce4_d3_code: "TFM Lokasjonskode: Kode [3]",
    ce109_id_or_parents: "MMI (Prosjektert)",
    ce146_id_or_parents: "Status (programert)",
    ce149_id_or_parents: "Entreprisenummer - Bygging",
    ce150_id_or_parents: "Entreprisenummer - Prosjektering",
    composite_1: "Spesiell funksjonell rolle",
    composite_2: "Utvidet TFM-ID",
    composite_34: "RefString",
    composite_35: "RefCompOcc_gammel",
    composite_36: "RefPriSysOcc",
    composite_37: "RefPriSysComp",
    composite_41: "RefCompOcc",
    occurrence_data_01_10_10_10: "NONS_BuildingControls - BuildingControls - ControlSystemType",
    occurrence_data_01_10_11_10: "NONS_BuildingControls - BuildingControls - ControlledBy",
    occurrence_data_13_10_01_01: "Felter for synkronisering - Global ID",
    occurrence_data_13_10_10_10: "Felter for synkronisering - Modellnavn",
    occurrence_data_13_10_11_10: "Felter for synkronisering - RefLocRoomServe",
    occurrence_data_03_01_01_01: "Automasjon, entreprenør - Generelt - Spenning (oppgitt)",
    occurrence_data_03_01_03_01: "Automasjon, entreprenør - Generelt - Frekvens (oppgitt)",
    occurrence_data_03_01_04_01: "Automasjon, entreprenør - Generelt - Effekt (oppgitt) - W",
    occurrence_data_03_01_05_01: "Automasjon, entreprenør - Generelt - Ampere (oppgitt) - A",
    occurrence_data_03_03_02_01: "Automasjon, entreprenør - Feltbus - Feltbus",
    occurrence_data_03_04_01_01: "Automasjon, entreprenør - Nettverk - Nettverksnavn",
    occurrence_data_03_04_02_01: "Automasjon, entreprenør - Nettverk - MAC adresse",
    occurrence_data_03_04_03_01: "Automasjon, entreprenør - Nettverk - IP adresse",
    article_id_dyn_article_20101010: "Artikkel: Elektro - Strømforsyning - Tilkobles strømforsyning - (Ja/Nei)",
    article_id_dyn_article_20101011: "Artikkel: Elektro - Strømforsyning - Tilkobles strømforsyning - (Flervalg)",
    article_id_dyn_article_20101110: "Artikkel: Elektro - Strømforsyning - Stikkontakt - (Numerisk)",
    article_id_dyn_article_20101111: "Artikkel: Elektro - Strømforsyning - Stikkontakt - (Tekst)",
    article_id_dyn_article_20101210: "Artikkel: Elektro - Strømforsyning - Fast tilkobling - (Numerisk)",
    article_id_dyn_article_20101211: "Artikkel: Elektro - Strømforsyning - Fast tilkobling - (Tekst)",
    article_id_dyn_article_20111610: "Artikkel: Elektro - Krav til strømforsyning - Normalkraft - (Ja/Nei)",
    article_id_dyn_article_20111611: "Artikkel: Elektro - Krav til strømforsyning - Normalkraft - (Flervalg)",
    article_id_dyn_article_20111010: "Artikkel: Elektro - Krav til strømforsyning - Resevekraft - (Ja/Nei)",
    article_id_dyn_article_20111012: "Artikkel: Elektro - Krav til strømforsyning - Resevekraft - (Flervalg)",
    article_id_dyn_article_20111110: "Artikkel: Elektro - Krav til strømforsyning - Avbruddsfri kraft (UPS) - (Ja/Nei)",
    article_id_dyn_article_20111112: "Artikkel: Elektro - Krav til strømforsyning - Avbruddsfri kraft (UPS) - (Flervalg)",
    article_id_dyn_article_20111410: "Artikkel: Elektro - Krav til strømforsyning - Annen strømstyrke - (Ja/Nei)",
    article_id_dyn_article_20111411: "Artikkel: Elektro - Krav til strømforsyning - Annen strømstyrke - A",
    article_id_dyn_article_20111510: "Artikkel: Elektro - Krav til strømforsyning - Krever separat kurs - (Ja/Nei)",
    article_id_dyn_article_20111511: "Artikkel: Elektro - Krav til strømforsyning - Krever separat kurs - Antall kurser",
    article_id_dyn_article_20111810: "Artikkel: Elektro - Krav til strømforsyning - Maks strømstyrke - (Ja/Nei)",
    article_id_dyn_article_20111811: "Artikkel: Elektro - Krav til strømforsyning - Maks strømstyrke - A",
    article_id_dyn_article_20121010: "Artikkel: Elektro - Effektbehov - Effekt ved normal drift (Pn) - (Ja/Nei)",
    article_id_dyn_article_20121011: "Artikkel: Elektro - Effektbehov - Effekt ved normal drift (Pn) - kW",
    article_id_dyn_article_20121810: "Artikkel: Elektro - Effektbehov - Effekt ved standby (Ps) - (Ja/Nei)",
    article_id_dyn_article_20121811: "Artikkel: Elektro - Effektbehov - Effekt ved standby (Ps) - kW",
    article_id_dyn_article_20121110: "Artikkel: Elektro - Effektbehov - Driftstid pr. døgn (d) - (Ja/Nei)",
    article_id_dyn_article_20121111: "Artikkel: Elektro - Effektbehov - Driftstid pr. døgn (d) - t",
    article_id_dyn_article_20121910: "Artikkel: Elektro - Effektbehov - Standbytid pr. døgn (s) - (Ja/Nei)",
    article_id_dyn_article_20121911: "Artikkel: Elektro - Effektbehov - Standbytid pr. døgn (s) - t",
    article_id_dyn_article_20121210: "Artikkel: Elektro - Effektbehov - Slås aldri av",
    article_id_dyn_article_19101010: "Artikkel: IKT - Nettverkstilkopling - Nettverk - (Ja/Nei)",
    article_id_dyn_article_19101011: "Artikkel: IKT - Nettverkstilkopling - Nettverk - (Flervalg)",
    article_id_dyn_article_19101111: "Artikkel: IKT - Nettverkstilkopling - Antall nettverkskontakter",
    article_id_dyn_article_19141110: "Artikkel: IKT - SD tilkopling - SD - (Ja/Nei)",
    article_id_dyn_article_19141111: "Artikkel: IKT - SD tilkopling - SD - (Flervalg)",
    article_id_dyn_article_19141210: "Artikkel: IKT - SD tilkopling - Tilkobles romkontroll",
    article_id_dyn_article_19141310: "Artikkel: IKT - SD tilkopling - Intern automatikk",
    article_id_dyn_article_19141410: "Artikkel: IKT - SD tilkopling - BUS kommunikasjon",
    article_id_dyn_article_02020101: "Artikkel: Automasjon - Feltbus - KNX - (Ja/Nei)",
    article_id_dyn_article_02020201: "Artikkel: Automasjon - Feltbus - Modbus RTU",
    article_id_dyn_article_02020601: "Artikkel: Automasjon - Feltbus - BACnet MS/TP",
    article_id_dyn_article_02020301: "Artikkel: Automasjon - Feltbus - M-Bus",
    article_id_dyn_article_02020401: "Artikkel: Automasjon - Feltbus - MP-Bus",
    article_id_dyn_article_02020501: "Artikkel: Automasjon - Feltbus - DALI",
    article_id_dyn_article_02010101: "Artikkel: Automasjon - Standard I/O - Digital inngang - (Ja/Nei)",
    article_id_dyn_article_02010102: "Artikkel: Automasjon - Standard I/O - Digital inngang - (Flervalg)",
    article_id_dyn_article_02010201: "Artikkel: Automasjon - Standard I/O - Digital utgang - (Ja/Nei)",
    article_id_dyn_article_02010202: "Artikkel: Automasjon - Standard I/O - Digital utgang - (Flervalg)",
    article_id_dyn_article_02010301: "Artikkel: Automasjon - Standard I/O - Analog inngang - (Ja/Nei)",
    article_id_dyn_article_02010302: "Artikkel: Automasjon - Standard I/O - Analog inngang - (Flervalg)",
    article_id_dyn_article_02010401: "Artikkel: Automasjon - Standard I/O - Analog utgang - (Ja/Nei)",
    article_id_dyn_article_02010402: "Artikkel: Automasjon - Standard I/O - Analog utgang - (Flervalg)",
    article_id_dyn_article_02030101: "Artikkel: Automasjon - Nettverk - BACnet IP",
    article_id_dyn_article_02030201: "Artikkel: Automasjon - Nettverk - Modbus TCP",
    article_id_dyn_article_02030301: "Artikkel: Automasjon - Nettverk - MQTT",
    article_id_dyn_article_17151011: "Artikkel: IKT 2 - Produktspesifikk - Building Controls - BUSCommunicationType",
    article_id_dyn_article_17151111: "Artikkel: IKT 2 - Produktspesifikk - Building Controls - BUSProtocolType",
    article_id_dyn_article_17151310: "Artikkel: IKT 2 - Produktspesifikk - Building Controls - HasInternalAutomation",
    article_id_dyn_article_14101010: "Artikkel: VVS - Tilkobling til vann/væsker - Kaldt vann - (Ja/Nei)",
    article_id_dyn_article_14101110: "Artikkel: VVS - Tilkobling til vann/væsker - Varmt vann - (Ja/Nei)",
    article_id_dyn_article_14101310: "Artikkel: VVS - Tilkobling til vann/væsker - Renset vann - (Ja/Nei)",
    article_id_dyn_article_14101810: "Artikkel: VVS - Tilkobling til vann/væsker - Andre væsker - (Ja/Nei)",
    article_id_dyn_article_14101610: "Artikkel: VVS - Tilkobling til vann/væsker - Kjølesystem - (Ja/Nei)",
    article_id_dyn_article_14111010: "Artikkel: VVS - Tilkobling til avløp - Avløp - (Ja/Nei)",
    article_id_dyn_article_14111110: "Artikkel: VVS - Tilkobling til avløp - Avløp med spesielle rensekrav - (Ja/Nei)",
    article_id_dyn_article_14111510: "Artikkel: VVS - Tilkobling til avløp - Sluk i gulv - (Ja/Nei)",
    article_id_dyn_article_14121010: "Artikkel: VVS - Tilkobling til ventilasjon/utløp - Tilluft - (Ja/Nei)",
    article_id_dyn_article_14121110: "Artikkel: VVS - Tilkobling til ventilasjon/utløp - Avtrekk/fraluft - (Ja/Nei)",
    article_id_dyn_article_14121210: "Artikkel: VVS - Tilkobling til ventilasjon/utløp - Avtrekk/fraluft via innebygget vifte - (Ja/Nei)",
    article_id_dyn_article_14121310: "Artikkel: VVS - Tilkobling til ventilasjon/utløp - Avsug - (Ja/Nei)",
    article_id_dyn_article_14151012: "Artikkel: VVS - Varmeavgivelse - Varme til luft ved normal drift > 1 kW - (Ja/Nei)",
    article_id_dyn_article_14161010: "Artikkel: VVS - Krav til temperatur/luftfuktighet - Romtemperatur - (Ja/Nei)",
    article_id_dyn_article_14161210: "Artikkel: VVS - Krav til temperatur/luftfuktighet - Luftfuktighet (% RH) - (Ja/Nei)",
    article_id_dyn_article_15101010: "Artikkel: Gass - Tilkobling til gass - Medisinsk luft, 400 kPa - (Ja/Nei)",
    article_id_dyn_article_15101110: "Artikkel: Gass - Tilkobling til gass - Instrumentluft, 800 kPa - (Ja/Nei)",
    article_id_dyn_article_15101210: "Artikkel: Gass - Tilkobling til gass - Teknisk trykkluft, 400 kPa - (Ja/Nei)",
    article_id_dyn_article_15101310: "Artikkel: Gass - Tilkobling til gass - Oksygen - (Ja/Nei)",
    article_id_dyn_article_15102110: "Artikkel: Gass - Tilkobling til gass - Lystgass - (Ja/Nei)",
    article_id_dyn_article_15102210: "Artikkel: Gass - Tilkobling til gass - CO2 - (Ja/Nei)",
    article_id_dyn_article_15101610: "Artikkel: Gass - Tilkobling til gass - Argon - (Ja/Nei)",
    article_id_dyn_article_15102010: "Artikkel: Gass - Tilkobling til gass - Hydrogen - (Ja/Nei)",
    article_id_dyn_article_15101710: "Artikkel: Gass - Tilkobling til gass - Nitrogen - (Ja/Nei)",
    article_id_dyn_article_15101810: "Artikkel: Gass - Tilkobling til gass - Flytende nitrogen - (Ja/Nei)",
    article_id_dyn_article_15101410: "Artikkel: Gass - Tilkobling til gass - Helium - (Ja/Nei)",
    article_id_dyn_article_15101510: "Artikkel: Gass - Tilkobling til gass - Flytende helium - (Ja/Nei)",
    article_id_dyn_article_15101910: "Artikkel: Gass - Tilkobling til gass - Propan - (Ja/Nei)",
    article_id_dyn_article_15121010: "Artikkel: Gass - Ut fra rommet - Gassutløp - (Ja/Nei)",
    article_id_dyn_article_15111010: "Artikkel: Gass - Annet gass",
};
export const DROFUS_INTERFACE_OCCURRENCE_NORMALIZED_PATHS = [
    "occurrence.id",
    "occurrence.quantity",
    "occurrence.existingQuantity",
    "occurrence.netQuantity",
    "occurrence.classificationNumber",
    "occurrence.runNo",
    "occurrence.name",
    "occurrence.comment",
    "occurrence.responsibility",
    "occurrence.overriddenResponsibility",
    "occurrence.priority",
    "occurrence.statusText",
    "occurrence.refString",
    "occurrence.extendedTfmId",
    "occurrence.refCompOcc",
    "occurrence.specialFunctionalRole",
    "occurrence.mmiCode",
    "occurrence.mmiIds",
    "occurrence.programmedStatusIds",
    "occurrence.isSubOccurrence",
    "occurrence.subOccurrenceDepth",
    "occurrence.hasIfcGuids",
    "occurrence.ifcGuids",
    "room.id",
    "room.functionNo",
    "room.architectNo",
    "room.fullName",
    "room.classification103Code",
    "article.id",
    "article.compCode",
    "article.name",
    "article.responsibility",
    "article.toBeDrawn",
    "article.bip",
    "system.primarySystemId",
    "system.isSystemComponent",
    "system.isComponent",
    "system.hasSystems",
    "system.systemMembership",
    "needs.electrical",
    "needs.ikt",
    "needs.automation",
    "needs.vvs",
    "needs.normalPowerKw",
    "needs.standbyPowerKw",
    "needs.networkOutletCount",
    "needs.sdConnection",
    "needs.roomControl",
    "needs.internalAutomation",
    "needs.busCommunication",
    "needs.vvsWater",
    "needs.vvsDrainage",
    "needs.vvsVentilation",
    "needs.vvsCooling",
    "needs.vvsHeatEmission",
    "needs.vvsTemperatureHumidity",
    "needs.medicalGas",
    "occurrenceData.controlSystemType",
    "occurrenceData.controlledBy",
    "occurrenceData.globalId",
    "occurrenceData.modelName",
    "occurrenceData.refLocRoomServe",
    "occurrenceData.statedVoltage",
    "occurrenceData.statedFrequency",
    "occurrenceData.statedPowerW",
    "occurrenceData.statedAmpere",
    "occurrenceData.fieldbus",
    "occurrenceData.networkName",
    "occurrenceData.macAddress",
    "occurrenceData.ipAddress",
];
export const DROFUS_INTERFACE_OCCURRENCE_NORMALIZED_PATH_BY_FIELD_ID = {
    id: "occurrence.id",
    quantity: "occurrence.quantity",
    existing_quantity: "occurrence.existingQuantity",
    net_quantity: "occurrence.netQuantity",
    classification_number: "occurrence.classificationNumber",
    run_no: "occurrence.runNo",
    occurrence_name: "occurrence.name",
    comment: "occurrence.comment",
    room_id: "room.id",
    room_id_room_func_no: "room.functionNo",
    room_id_architect_no: "room.architectNo",
    room_id_full_name: "room.fullName",
    room_id_room_classification_103_classification_entry_id_code: "room.classification103Code",
    article_id: "article.id",
    article_id_number: "article.compCode",
    article_id_name: "article.name",
    article_id_responsibility_responsibility: "article.responsibility",
    article_id_to_be_drawn: "article.toBeDrawn",
    article_id_bip: "article.bip",
    occurrence_responsibility: "occurrence.responsibility",
    responsibility: "occurrence.overriddenResponsibility",
    priority: "occurrence.priority",
    primary_system_id: "system.primarySystemId",
    is_sub_occurrence: "occurrence.isSubOccurrence",
    sub_occurrence_depth: "occurrence.subOccurrenceDepth",
    has_ifc_guids: "occurrence.hasIfcGuids",
    ifc_guids: "occurrence.ifcGuids",
    status_text: "occurrence.statusText",
    is_system_component: "system.isSystemComponent",
    is_component: "system.isComponent",
    is_base_for_systems: "system.hasSystems",
    system_membership: "system.systemMembership",
    occurrence_classification_109_classification_entry_id_code: "occurrence.mmiCode",
    ce109_id_or_parents: "occurrence.mmiIds",
    ce146_id_or_parents: "occurrence.programmedStatusIds",
    composite_1: "occurrence.specialFunctionalRole",
    composite_2: "occurrence.extendedTfmId",
    composite_34: "occurrence.refString",
    composite_41: "occurrence.refCompOcc",
    occurrence_data_01_10_10_10: "occurrenceData.controlSystemType",
    occurrence_data_01_10_11_10: "occurrenceData.controlledBy",
    occurrence_data_13_10_01_01: "occurrenceData.globalId",
    occurrence_data_13_10_10_10: "occurrenceData.modelName",
    occurrence_data_13_10_11_10: "occurrenceData.refLocRoomServe",
    occurrence_data_03_01_01_01: "occurrenceData.statedVoltage",
    occurrence_data_03_01_03_01: "occurrenceData.statedFrequency",
    occurrence_data_03_01_04_01: "occurrenceData.statedPowerW",
    occurrence_data_03_01_05_01: "occurrenceData.statedAmpere",
    occurrence_data_03_03_02_01: "occurrenceData.fieldbus",
    occurrence_data_03_04_01_01: "occurrenceData.networkName",
    occurrence_data_03_04_02_01: "occurrenceData.macAddress",
    occurrence_data_03_04_03_01: "occurrenceData.ipAddress",
    article_id_dyn_article_20101010: "needs.electrical",
    article_id_dyn_article_20121011: "needs.normalPowerKw",
    article_id_dyn_article_20121811: "needs.standbyPowerKw",
    article_id_dyn_article_19101010: "needs.ikt",
    article_id_dyn_article_19101111: "needs.networkOutletCount",
    article_id_dyn_article_19141110: "needs.sdConnection",
    article_id_dyn_article_19141210: "needs.roomControl",
    article_id_dyn_article_19141310: "needs.internalAutomation",
    article_id_dyn_article_19141410: "needs.busCommunication",
    article_id_dyn_article_02020101: "needs.automation",
    article_id_dyn_article_02020201: "needs.automation",
    article_id_dyn_article_02020601: "needs.automation",
    article_id_dyn_article_02020301: "needs.automation",
    article_id_dyn_article_02020401: "needs.automation",
    article_id_dyn_article_02020501: "needs.automation",
    article_id_dyn_article_02010101: "needs.automation",
    article_id_dyn_article_02010201: "needs.automation",
    article_id_dyn_article_02010301: "needs.automation",
    article_id_dyn_article_02010401: "needs.automation",
    article_id_dyn_article_02030101: "needs.automation",
    article_id_dyn_article_02030201: "needs.automation",
    article_id_dyn_article_02030301: "needs.automation",
    article_id_dyn_article_17151310: "needs.internalAutomation",
    article_id_dyn_article_14101010: "needs.vvsWater",
    article_id_dyn_article_14101110: "needs.vvsWater",
    article_id_dyn_article_14101310: "needs.vvsWater",
    article_id_dyn_article_14101810: "needs.vvsWater",
    article_id_dyn_article_14101610: "needs.vvsCooling",
    article_id_dyn_article_14111010: "needs.vvsDrainage",
    article_id_dyn_article_14111110: "needs.vvsDrainage",
    article_id_dyn_article_14111510: "needs.vvsDrainage",
    article_id_dyn_article_14121010: "needs.vvsVentilation",
    article_id_dyn_article_14121110: "needs.vvsVentilation",
    article_id_dyn_article_14121210: "needs.vvsVentilation",
    article_id_dyn_article_14121310: "needs.vvsVentilation",
    article_id_dyn_article_14151012: "needs.vvsHeatEmission",
    article_id_dyn_article_14161010: "needs.vvsTemperatureHumidity",
    article_id_dyn_article_14161210: "needs.vvsTemperatureHumidity",
    article_id_dyn_article_15101010: "needs.medicalGas",
    article_id_dyn_article_15101110: "needs.medicalGas",
    article_id_dyn_article_15101210: "needs.medicalGas",
    article_id_dyn_article_15101310: "needs.medicalGas",
    article_id_dyn_article_15102110: "needs.medicalGas",
    article_id_dyn_article_15102210: "needs.medicalGas",
    article_id_dyn_article_15101610: "needs.medicalGas",
    article_id_dyn_article_15102010: "needs.medicalGas",
    article_id_dyn_article_15101710: "needs.medicalGas",
    article_id_dyn_article_15101810: "needs.medicalGas",
    article_id_dyn_article_15101410: "needs.medicalGas",
    article_id_dyn_article_15101510: "needs.medicalGas",
    article_id_dyn_article_15101910: "needs.medicalGas",
    article_id_dyn_article_15121010: "needs.medicalGas",
    article_id_dyn_article_15111010: "needs.medicalGas",
};
export const DROFUS_INTERFACE_OCCURRENCE_NEED_DISCIPLINE_BY_PATH = {
    "needs.electrical": "RIE",
    "needs.ikt": "RIKT",
    "needs.automation": "RIAut",
    "needs.vvs": "RIV",
    "needs.normalPowerKw": "RIE",
    "needs.standbyPowerKw": "RIE",
    "needs.networkOutletCount": "RIKT",
    "needs.sdConnection": "RIKT",
    "needs.roomControl": "RIKT",
    "needs.internalAutomation": "RIAut",
    "needs.busCommunication": "RIKT",
    "needs.vvsWater": "RIV",
    "needs.vvsDrainage": "RIV",
    "needs.vvsVentilation": "RIV",
    "needs.vvsCooling": "RIV",
    "needs.vvsHeatEmission": "RIV",
    "needs.vvsTemperatureHumidity": "RIV",
    "needs.medicalGas": "RIV",
};
export const DROFUS_INTERFACE_OCCURRENCE_NEED_TRUTHY_RULES = [
    "true => behov",
    "number > 0 => behov",
    "ikke-tom tekst => behov",
    "false, 0, null, undefined og tom tekst => ikke behov",
];
export const DROFUS_INTERFACE_OCCURRENCE_NEED_RULES = {
    electrical: {
        label: "Elektro",
        affectedDiscipline: "RIE",
        normalizedPath: "needs.electrical",
        sourceFieldIds: [
            "article_id_dyn_article_20101010",
            "article_id_dyn_article_20101110",
            "article_id_dyn_article_20101210",
            "article_id_dyn_article_20111610",
            "article_id_dyn_article_20111010",
            "article_id_dyn_article_20111110",
            "article_id_dyn_article_20111410",
            "article_id_dyn_article_20111510",
            "article_id_dyn_article_20111810",
            "article_id_dyn_article_20121010",
            "article_id_dyn_article_20121011",
            "article_id_dyn_article_20121810",
            "article_id_dyn_article_20121811",
        ],
    },
    ikt: {
        label: "IKT",
        affectedDiscipline: "RIKT",
        normalizedPath: "needs.ikt",
        sourceFieldIds: [
            "article_id_dyn_article_19101010",
            "article_id_dyn_article_19101111",
            "article_id_dyn_article_19141110",
            "article_id_dyn_article_19141210",
            "article_id_dyn_article_19141310",
            "article_id_dyn_article_19141410",
            "article_id_dyn_article_17151011",
            "article_id_dyn_article_17151111",
            "article_id_dyn_article_17151310",
        ],
    },
    automation: {
        label: "Automasjon",
        affectedDiscipline: "RIAut",
        normalizedPath: "needs.automation",
        sourceFieldIds: [
            "article_id_dyn_article_02020101",
            "article_id_dyn_article_02020201",
            "article_id_dyn_article_02020601",
            "article_id_dyn_article_02020301",
            "article_id_dyn_article_02020401",
            "article_id_dyn_article_02020501",
            "article_id_dyn_article_02010101",
            "article_id_dyn_article_02010201",
            "article_id_dyn_article_02010301",
            "article_id_dyn_article_02010401",
            "article_id_dyn_article_02030101",
            "article_id_dyn_article_02030201",
            "article_id_dyn_article_02030301",
            "occurrence_data_01_10_10_10",
            "occurrence_data_01_10_11_10",
            "occurrence_data_03_03_02_01",
        ],
    },
    vvsWater: {
        label: "VVS: Vann/væsker",
        affectedDiscipline: "RIV",
        normalizedPath: "needs.vvsWater",
        sourceFieldIds: [
            "article_id_dyn_article_14101010",
            "article_id_dyn_article_14101110",
            "article_id_dyn_article_14101310",
            "article_id_dyn_article_14101810",
        ],
    },
    vvsDrainage: {
        label: "VVS: Avløp",
        affectedDiscipline: "RIV",
        normalizedPath: "needs.vvsDrainage",
        sourceFieldIds: [
            "article_id_dyn_article_14111010",
            "article_id_dyn_article_14111110",
            "article_id_dyn_article_14111510",
        ],
    },
    vvsVentilation: {
        label: "VVS: Ventilasjon/utløp",
        affectedDiscipline: "RIV",
        normalizedPath: "needs.vvsVentilation",
        sourceFieldIds: [
            "article_id_dyn_article_14121010",
            "article_id_dyn_article_14121110",
            "article_id_dyn_article_14121210",
            "article_id_dyn_article_14121310",
        ],
    },
    vvsCooling: {
        label: "VVS: Kjøling",
        affectedDiscipline: "RIV",
        normalizedPath: "needs.vvsCooling",
        sourceFieldIds: ["article_id_dyn_article_14101610"],
    },
    vvsHeatEmission: {
        label: "VVS: Varmeavgivelse",
        affectedDiscipline: "RIV",
        normalizedPath: "needs.vvsHeatEmission",
        sourceFieldIds: ["article_id_dyn_article_14151012"],
    },
    vvsTemperatureHumidity: {
        label: "VVS: Temperatur/luftfuktighet",
        affectedDiscipline: "RIV",
        normalizedPath: "needs.vvsTemperatureHumidity",
        sourceFieldIds: [
            "article_id_dyn_article_14161010",
            "article_id_dyn_article_14161210",
        ],
    },
    medicalGas: {
        label: "Gass: Medisinsk/teknisk gass",
        affectedDiscipline: "RIV",
        normalizedPath: "needs.medicalGas",
        sourceFieldIds: [
            "article_id_dyn_article_15101010",
            "article_id_dyn_article_15101110",
            "article_id_dyn_article_15101210",
            "article_id_dyn_article_15101310",
            "article_id_dyn_article_15102110",
            "article_id_dyn_article_15102210",
            "article_id_dyn_article_15101610",
            "article_id_dyn_article_15102010",
            "article_id_dyn_article_15101710",
            "article_id_dyn_article_15101810",
            "article_id_dyn_article_15101410",
            "article_id_dyn_article_15101510",
            "article_id_dyn_article_15101910",
            "article_id_dyn_article_15121010",
            "article_id_dyn_article_15111010",
        ],
    },
};
export const DROFUS_INTERFACE_OCCURRENCE_DERIVED_NEED_RULES = {
    vvs: {
        label: "VVS samlet",
        affectedDiscipline: "RIV",
        normalizedPath: "needs.vvs",
        sourceNeedKeys: [
            "vvsWater",
            "vvsDrainage",
            "vvsVentilation",
            "vvsCooling",
            "vvsHeatEmission",
            "vvsTemperatureHumidity",
            "medicalGas",
        ],
    },
};
// Fields describing model synchronization rather than engineering requirements.
export const DROFUS_INTERFACE_SYNCHRONIZATION_FIELD_IDS = [
    "ifc_guids",
    "has_ifc_guids",
    "occurrence_data_13_10_01_01",
    "composite_34", // RefString
    "classification_number", // Nummer
    "composite_2", // Utvidet TFM-ID
];
// Room descriptions remain available as context, but belong to room/RFP validation.
// room.id is the occurrence's room assignment and must still produce a change.
export function getDrofusInterfaceChangeCategory(path) {
    if (path === "occurrence.mmiIds")
        return "internal";
    if (path === "article.name")
        return "articleContext";
    if (path?.startsWith("room.") && path !== "room.id")
        return "roomContext";
    if (DROFUS_INTERFACE_SYNCHRONIZATION_FIELD_IDS.some(id => DROFUS_INTERFACE_OCCURRENCE_NORMALIZED_PATH_BY_FIELD_ID[id] === path))
        return "synchronization";
    return "ordinary";
}
export const DROFUS_INTERFACE_OCCURRENCE_CHANGE_PATHS = DROFUS_INTERFACE_OCCURRENCE_NORMALIZED_PATHS.filter(path => !["roomContext", "articleContext", "internal"].includes(getDrofusInterfaceChangeCategory(path)));
export const DROFUS_INTERFACE_OCCURRENCE_FIELD_META = DROFUS_INTERFACE_OCCURRENCE_SELECT_FIELDS.map((id) => {
    const normalizedPath = DROFUS_INTERFACE_OCCURRENCE_NORMALIZED_PATH_BY_FIELD_ID[id];
    return {
        id,
        displayName: DROFUS_INTERFACE_OCCURRENCE_FIELD_LABELS[id],
        changeCategory: getDrofusInterfaceChangeCategory(normalizedPath),
        group: DROFUS_INTERFACE_OCCURRENCE_FIELD_GROUP_BY_ID[id],
        normalizedPath,
        affectedDiscipline: normalizedPath &&
            normalizedPath in DROFUS_INTERFACE_OCCURRENCE_NEED_DISCIPLINE_BY_PATH
            ? DROFUS_INTERFACE_OCCURRENCE_NEED_DISCIPLINE_BY_PATH[normalizedPath]
            : undefined,
    };
});
export const DROFUS_INTERFACE_OCCURRENCE_SELECT = DROFUS_INTERFACE_OCCURRENCE_SELECT_FIELDS.join(",");
export const DROFUS_INTERFACE_OCCURRENCE_J_ROOMS_FILTER = "startswith(room_id_room_classification_103_classification_entry_id_code,'J') and " + DROFUS_MODELLED_MAIN_FILTER;
export const ZDrofusInterfaceOccurrence = z
    .object({
    id: z.number().int(),
    quantity: nullableNumber,
    existing_quantity: nullableNumber,
    net_quantity: nullableNumber,
    classification_number: nullableString,
    run_no: nullableString,
    occurrence_name: nullableString,
    comment: nullableString,
    equipment_list_type_id: nullableNumber,
    equipment_list_type_id_name: nullableString,
    room_id: nullableNumber,
    room_id_room_func_no: nullableString,
    room_id_architect_no: nullableString,
    room_id_full_name: nullableString,
    room_id_room_classification_103_classification_entry_id_code: nullableString,
    room_id_room_classification_109_classification_entry_id_code: nullableString,
    article_id: nullableNumber,
    article_id_number: nullableString,
    article_id_name: nullableString,
    article_id_responsibility_responsibility: nullableString,
    article_id_to_be_drawn: nullableBoolean,
    article_id_bip: nullableBoolean,
    occurrence_responsibility: nullableString,
    responsibility: nullableString,
    priority: nullableString,
    primary_system_id: nullableNumber,
    is_sub_occurrence: nullableBoolean,
    sub_occurrence_depth: nullableNumber,
    has_ifc_guids: nullableBoolean,
    ifc_guids: z.union([nullableStringArray, nullableString]).optional(),
    status_text: nullableString,
    name_or_item_name: nullableString,
    occurrence_classification_109_classification_entry_id_code: nullableString,
    is_system_component: nullableBoolean,
    is_component: nullableBoolean,
    is_base_for_systems: nullableString,
    system_membership: nullableString,
    ce4_d1_code: nullableString,
    ce4_d2_code: nullableString,
    ce4_d3_code: nullableString,
    ce109_id_or_parents: nullableNumberArray,
    ce146_id_or_parents: nullableNumberArray,
    ce149_id_or_parents: nullableNumberArray,
    ce150_id_or_parents: nullableNumberArray,
    composite_1: nullableString,
    composite_2: nullableString,
    composite_34: nullableString,
    composite_35: nullableString,
    composite_36: nullableString,
    composite_37: nullableString,
    composite_41: nullableStringOrNumber,
    occurrence_data_01_10_10_10: nullableString,
    occurrence_data_01_10_11_10: nullableString,
    occurrence_data_13_10_01_01: nullableString,
    occurrence_data_13_10_10_10: nullableString,
    occurrence_data_13_10_11_10: nullableString,
    occurrence_data_03_01_01_01: nullableString,
    occurrence_data_03_01_03_01: nullableString,
    occurrence_data_03_01_04_01: nullableNumber,
    occurrence_data_03_01_05_01: nullableNumber,
    occurrence_data_03_03_02_01: nullableBoolean,
    occurrence_data_03_04_01_01: nullableString,
    occurrence_data_03_04_02_01: nullableString,
    occurrence_data_03_04_03_01: nullableString,
    article_id_dyn_article_20101010: nullableBoolean,
    article_id_dyn_article_20101011: nullableString,
    article_id_dyn_article_20101110: nullableNumber,
    article_id_dyn_article_20101111: nullableString,
    article_id_dyn_article_20101210: nullableNumber,
    article_id_dyn_article_20101211: nullableString,
    article_id_dyn_article_20111610: nullableBoolean,
    article_id_dyn_article_20111611: nullableString,
    article_id_dyn_article_20111010: nullableBoolean,
    article_id_dyn_article_20111012: nullableString,
    article_id_dyn_article_20111110: nullableBoolean,
    article_id_dyn_article_20111112: nullableString,
    article_id_dyn_article_20111410: nullableBoolean,
    article_id_dyn_article_20111411: nullableNumber,
    article_id_dyn_article_20111510: nullableBoolean,
    article_id_dyn_article_20111511: nullableNumber,
    article_id_dyn_article_20111810: nullableBoolean,
    article_id_dyn_article_20111811: nullableNumber,
    article_id_dyn_article_20121010: nullableBoolean,
    article_id_dyn_article_20121011: nullableNumber,
    article_id_dyn_article_20121810: nullableBoolean,
    article_id_dyn_article_20121811: nullableNumber,
    article_id_dyn_article_20121110: nullableBoolean,
    article_id_dyn_article_20121111: nullableNumber,
    article_id_dyn_article_20121910: nullableBoolean,
    article_id_dyn_article_20121911: nullableNumber,
    article_id_dyn_article_20121210: nullableBoolean,
    article_id_dyn_article_19101010: nullableBoolean,
    article_id_dyn_article_19101011: nullableString,
    article_id_dyn_article_19101111: nullableNumber,
    article_id_dyn_article_19141110: nullableBoolean,
    article_id_dyn_article_19141111: nullableString,
    article_id_dyn_article_19141210: nullableBoolean,
    article_id_dyn_article_19141310: nullableBoolean,
    article_id_dyn_article_19141410: nullableBoolean,
    article_id_dyn_article_02020101: nullableBoolean,
    article_id_dyn_article_02020201: nullableBoolean,
    article_id_dyn_article_02020601: nullableBoolean,
    article_id_dyn_article_02020301: nullableBoolean,
    article_id_dyn_article_02020401: nullableBoolean,
    article_id_dyn_article_02020501: nullableBoolean,
    article_id_dyn_article_02010101: nullableBoolean,
    article_id_dyn_article_02010102: nullableString,
    article_id_dyn_article_02010201: nullableBoolean,
    article_id_dyn_article_02010202: nullableString,
    article_id_dyn_article_02010301: nullableBoolean,
    article_id_dyn_article_02010302: nullableString,
    article_id_dyn_article_02010401: nullableBoolean,
    article_id_dyn_article_02010402: nullableString,
    article_id_dyn_article_02030101: nullableBoolean,
    article_id_dyn_article_02030201: nullableBoolean,
    article_id_dyn_article_02030301: nullableBoolean,
    article_id_dyn_article_17151011: nullableString,
    article_id_dyn_article_17151111: nullableString,
    article_id_dyn_article_17151310: nullableBoolean,
    article_id_dyn_article_14101010: nullableBoolean,
    article_id_dyn_article_14101110: nullableBoolean,
    article_id_dyn_article_14101310: nullableBoolean,
    article_id_dyn_article_14101810: nullableBoolean,
    article_id_dyn_article_14101610: nullableBoolean,
    article_id_dyn_article_14111010: nullableBoolean,
    article_id_dyn_article_14111110: nullableBoolean,
    article_id_dyn_article_14111510: nullableBoolean,
    article_id_dyn_article_14121010: nullableBoolean,
    article_id_dyn_article_14121110: nullableBoolean,
    article_id_dyn_article_14121210: nullableBoolean,
    article_id_dyn_article_14121310: nullableBoolean,
    article_id_dyn_article_14151012: nullableBoolean,
    article_id_dyn_article_14161010: nullableBoolean,
    article_id_dyn_article_14161210: nullableBoolean,
    article_id_dyn_article_15101010: nullableBoolean,
    article_id_dyn_article_15101110: nullableBoolean,
    article_id_dyn_article_15101210: nullableBoolean,
    article_id_dyn_article_15101310: nullableBoolean,
    article_id_dyn_article_15102110: nullableBoolean,
    article_id_dyn_article_15102210: nullableBoolean,
    article_id_dyn_article_15101610: nullableBoolean,
    article_id_dyn_article_15102010: nullableBoolean,
    article_id_dyn_article_15101710: nullableBoolean,
    article_id_dyn_article_15101810: nullableBoolean,
    article_id_dyn_article_15101410: nullableBoolean,
    article_id_dyn_article_15101510: nullableBoolean,
    article_id_dyn_article_15101910: nullableBoolean,
    article_id_dyn_article_15121010: nullableBoolean,
    article_id_dyn_article_15111010: nullableString,
})
    .passthrough();
export const ZDrofusInterfaceOccurrencesResponse = z.array(ZDrofusInterfaceOccurrence);
export const ZDrofusInterfaceOccurrenceFieldId = z.enum(DROFUS_INTERFACE_OCCURRENCE_SELECT_FIELDS);
export const ZDrofusInterfaceDiscipline = z.enum([
    "RIV",
    "RIE",
    "RIAut",
    "RIKT",
    "ARK",
    "IARK",
    "RKJ",
    "RUT",
    "HF",
    "UNKNOWN",
]);
export const ZDrofusInterfaceSnapshotRunStatus = z.enum([
    "queued",
    "running",
    "succeeded",
    "test_completed",
    "partial",
    "dry_run_completed",
    "failed",
    "canceled",
]);
export const ZDrofusInterfaceSnapshotRunPageTiming = z.object({
    page: z.number().int().positive(),
    skip: z.number().int().nonnegative().optional().nullable(),
    top: z.number().int().positive().optional().nullable(),
    fetchedRowCount: z.number().int().nonnegative(),
    totalFetchedRowCount: z.number().int().nonnegative(),
    savedSnapshotCount: z.number().int().nonnegative().optional(),
    interfaceRelevantCount: z.number().int().nonnegative().optional(),
    hasNext: z.boolean(),
    fetchMs: z.number().int().nonnegative(),
    jsonMs: z.number().int().nonnegative(),
    processMs: z.number().int().nonnegative().optional(),
    saveMs: z.number().int().nonnegative().optional(),
    totalMs: z.number().int().nonnegative(),
    capturedAt: ZDateish,
});
export const ZDrofusInterfaceSnapshotRun = z.object({
    _id: ZObjectIdString.optional(),
    projectNo: ZProjectNo,
    source: z.literal("drofus").default("drofus"),
    entityType: z.literal("occurrence").default("occurrence"),
    status: ZDrofusInterfaceSnapshotRunStatus,
    testMode: z.boolean().optional(),
    trigger: z.enum(["manual", "scheduled", "retry", "backfill"]),
    startedAt: ZDateish,
    finishedAt: ZDateish.optional().nullable(),
    elapsedMs: z.number().int().nonnegative().optional(),
    previousRunId: ZObjectIdString.optional().nullable(),
    diffBaseRunId: ZObjectIdString.optional().nullable(),
    api: z.object({
        baseUrl: z.string().url().optional(),
        db: z.string().min(1).optional(),
        project: z.string().min(1).optional(),
        endpoint: z.literal("occurrences").default("occurrences"),
        select: z.string().min(1),
        selectHash: z.string().min(1),
        articleProperties: z.array(ZDrofusArticleProperty).optional(),
        filter: z.string().min(1).optional().nullable(),
        pageSize: z.number().int().positive(),
    }),
    result: z
        .object({
        pageCount: z.number().int().nonnegative(),
        fetchedRowCount: z.number().int().nonnegative(),
        savedSnapshotCount: z.number().int().nonnegative().optional(),
        articleSnapshotComplete: z.boolean().optional(),
        interfaceRelevantCount: z.number().int().nonnegative().optional(),
        addedCount: z.number().int().nonnegative().optional(),
        updatedCount: z.number().int().nonnegative().optional(),
        removedCount: z.number().int().nonnegative().optional(),
        changeEventCount: z.number().int().nonnegative().optional(),
        pageTimings: z.array(ZDrofusInterfaceSnapshotRunPageTiming).optional(),
    })
        .optional(),
    error: z
        .object({
        origin: z
            .enum(["upstream", "config", "network", "db", "validation", "unknown"])
            .optional(),
        code: z.string().or(z.number()).optional(),
        message: z.string(),
        stack: z.string().optional(),
    })
        .optional(),
    meta: z
        .object({
        functionName: z.string().optional(),
        invocationId: z.string().optional(),
        hostInstanceId: z.string().optional(),
        schemaVersion: z.string().default("1"),
        workerFunctionName: z.string().optional(),
        workerInvocationId: z.string().optional(),
        queuedAt: ZDateish.optional(),
        maxRows: z.number().int().positive().optional().nullable(),
        pageSize: z.number().int().positive().optional(),
        currentSkip: z.number().int().nonnegative().optional().nullable(),
        nextSkip: z.number().int().nonnegative().optional().nullable(),
        lastPageAt: ZDateish.optional(),
        repairedAt: ZDateish.optional(),
        repairReason: z.string().optional(),
        maxPages: z.number().int().positive().optional().nullable(),
        chunk: z
            .object({
            startedAt: ZDateish.optional(),
            finishedAt: ZDateish.optional(),
            elapsedMs: z.number().int().nonnegative().optional(),
            pageCount: z.number().int().nonnegative().optional(),
            startSkip: z.number().int().nonnegative().optional().nullable(),
            nextSkip: z.number().int().nonnegative().optional().nullable(),
            maxPages: z.number().int().positive().optional().nullable(),
        })
            .optional(),
    })
        .optional(),
});
export const ZDrofusInterfaceNormalizedOccurrence = z.object({
    occurrence: z.object({
        id: z.number().int(),
        quantity: nullableNumber,
        existingQuantity: nullableNumber,
        netQuantity: nullableNumber,
        classificationNumber: nullableString,
        runNo: nullableString,
        name: nullableString,
        comment: nullableString,
        responsibility: nullableString,
        overriddenResponsibility: nullableString,
        priority: nullableString,
        statusText: nullableString,
        refString: nullableString,
        extendedTfmId: nullableString,
        refCompOcc: z.string().or(z.number()).nullable().optional(),
        specialFunctionalRole: nullableString,
        mmiCode: nullableString,
        mmiIds: nullableNumberArray,
        programmedStatusIds: nullableNumberArray,
        isSubOccurrence: nullableBoolean,
        subOccurrenceDepth: nullableNumber,
        hasIfcGuids: nullableBoolean,
        ifcGuids: z.union([nullableStringArray, nullableString]).optional(),
    }),
    room: z.object({
        id: nullableNumber,
        functionNo: nullableString,
        architectNo: nullableString,
        fullName: nullableString,
        classification103Code: nullableString,
        classification109Code: nullableString,
    }),
    article: z.object({
        id: nullableNumber,
        compCode: nullableString,
        properties: z.record(z.string(), z.string().nullable()).optional(),
        name: nullableString,
        responsibility: nullableString,
        toBeDrawn: nullableBoolean,
        bip: nullableBoolean,
    }),
    system: z.object({
        primarySystemId: nullableNumber,
        isSystemComponent: nullableBoolean,
        isComponent: nullableBoolean,
        hasSystems: nullableString,
        systemMembership: nullableString,
    }),
    needs: z.object({
        electrical: z.boolean(),
        ikt: z.boolean(),
        automation: z.boolean(),
        vvs: z.boolean(),
        normalPowerKw: nullableNumber,
        standbyPowerKw: nullableNumber,
        networkOutletCount: nullableNumber,
        sdConnection: nullableBoolean,
        roomControl: nullableBoolean,
        internalAutomation: nullableBoolean,
        busCommunication: nullableBoolean,
        vvsWater: z.boolean(),
        vvsDrainage: z.boolean(),
        vvsVentilation: z.boolean(),
        vvsCooling: z.boolean(),
        vvsHeatEmission: z.boolean(),
        vvsTemperatureHumidity: z.boolean(),
        medicalGas: z.boolean(),
    }),
    occurrenceData: z.object({
        controlSystemType: nullableString,
        controlledBy: nullableString,
        globalId: nullableString,
        modelName: nullableString,
        refLocRoomServe: nullableString,
        statedVoltage: nullableString,
        statedFrequency: nullableString,
        statedPowerW: nullableNumber,
        statedAmpere: nullableNumber,
        fieldbus: nullableBoolean,
        networkName: nullableString,
        macAddress: nullableString,
        ipAddress: nullableString,
    }),
});
export const ZDrofusInterfaceOccurrenceSnapshot = z.object({
    _id: ZObjectIdString.optional(),
    projectNo: ZProjectNo,
    runId: ZObjectIdString,
    capturedAt: ZDateish,
    entityType: z.literal("occurrence").default("occurrence"),
    occurrenceId: z.number().int(),
    stableKey: z.string().min(1),
    normalized: ZDrofusInterfaceNormalizedOccurrence,
    sourceValues: z.record(z.string(), sourceValue).optional(),
    contentHash: z.string().min(1),
    normalizedHash: z.string().min(1).optional(),
    interfaceRelevant: z.boolean(),
    interfaceRelevantReasons: z.array(z.string()).default([]),
    affectedDisciplines: z.array(ZDrofusInterfaceDiscipline).default([]),
});
// Omitting runId explicitly requests the latest retained snapshot for this occurrence.
export const ZDrofusInterfaceOccurrenceDetailsInput = ZDrofusInterfaceOccurrenceSnapshot
    .pick({ projectNo: true, runId: true, occurrenceId: true })
    .extend({
    runId: ZDrofusInterfaceOccurrenceSnapshot.shape.runId.optional(),
    occurrenceId: ZDrofusInterfaceOccurrenceSnapshot.shape.occurrenceId.positive(),
});
export const ZDrofusInterfaceOccurrenceLiveInput = ZDrofusInterfaceOccurrenceDetailsInput.omit({ runId: true });
export const ZDrofusInterfaceOccurrenceLiveResponse = ZDrofusInterfaceOccurrenceSnapshot
    .omit({ _id: true, runId: true, contentHash: true, normalizedHash: true })
    .extend({
    source: z.literal("live"),
    runId: z.null().optional(),
    contentHash: z.null().optional(),
    normalizedHash: z.null().optional(),
});
